/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalcolaOreMancantiResponseDTO
 */
export interface CalcolaOreMancantiResponseDTO {
    /**
     * 
     * @type {Date}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    giorno?: Date;
    /**
     * 
     * @type {number}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    oreLavorate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    festivo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    completo?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    readonly giornoString?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CalcolaOreMancantiResponseDTO
     */
    oreMancanti?: number;
}

/**
 * Check if a given object implements the CalcolaOreMancantiResponseDTO interface.
 */
export function instanceOfCalcolaOreMancantiResponseDTO(value: object): value is CalcolaOreMancantiResponseDTO {
    return true;
}

export function CalcolaOreMancantiResponseDTOFromJSON(json: any): CalcolaOreMancantiResponseDTO {
    return CalcolaOreMancantiResponseDTOFromJSONTyped(json, false);
}

export function CalcolaOreMancantiResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcolaOreMancantiResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'giorno': json['giorno'] == null ? undefined : (new Date(json['giorno'])),
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
        'festivo': json['festivo'] == null ? undefined : json['festivo'],
        'completo': json['completo'] == null ? undefined : json['completo'],
        'giornoString': json['giornoString'] == null ? undefined : json['giornoString'],
        'oreMancanti': json['oreMancanti'] == null ? undefined : json['oreMancanti'],
    };
}

export function CalcolaOreMancantiResponseDTOToJSON(json: any): CalcolaOreMancantiResponseDTO {
    return CalcolaOreMancantiResponseDTOToJSONTyped(json, false);
}

export function CalcolaOreMancantiResponseDTOToJSONTyped(value?: Omit<CalcolaOreMancantiResponseDTO, 'giornoString'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'giorno': value['giorno'] == null ? undefined : ((value['giorno']).toISOString()),
        'oreLavorate': value['oreLavorate'],
        'festivo': value['festivo'],
        'completo': value['completo'],
        'oreMancanti': value['oreMancanti'],
    };
}

